"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ky_imlpConfig_1 = require("../config/ky.imlpConfig");
var service_status_enum_1 = __importDefault(require("../enums/service-status.enum"));
var getDefaultParams_1 = __importDefault(require("../helpers/getDefaultParams"));
var EducatorUserService = {
    authenticateUser: function (authenticateObj) { return __awaiter(void 0, void 0, void 0, function () {
        var params, url, response, data, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    params = (0, getDefaultParams_1.default)();
                    url = "".concat(params.educatorUserUrl, "/api/authenticateuser");
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, (0, ky_imlpConfig_1.post)(url, { json: authenticateObj })];
                case 2:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 3:
                    data = _a.sent();
                    return [2 /*return*/, { status: service_status_enum_1.default.LOADED, data: data }];
                case 4:
                    error_1 = _a.sent();
                    console.log(error_1);
                    return [2 /*return*/, { status: service_status_enum_1.default.ERROR, data: error_1 }];
                case 5: return [2 /*return*/];
            }
        });
    }); },
    getStudentLoginDetails: function () {
        var params = (0, getDefaultParams_1.default)();
        var url = "".concat(params.educatorUserUrl, "/studentlogindetails");
        return (0, ky_imlpConfig_1.get)(url)
            .then(function (response) { return response.json(); })
            .then(function (response) { return ({ status: service_status_enum_1.default.LOADED, data: response }); })
            .catch(function (error) { return ({ status: service_status_enum_1.default.ERROR, data: error }); });
    },
    studentLogoutEvent: function (userId, clientDateTime, userAgent) { return __awaiter(void 0, void 0, void 0, function () {
        var params, url, jsonObj, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    params = (0, getDefaultParams_1.default)();
                    url = "".concat(params.educatorUserUrl, "/api/studentlogoutEvent");
                    jsonObj = {
                        userId: userId,
                        clientDateTime: clientDateTime,
                        userAgent: userAgent,
                        userRole: "Student"
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, (0, ky_imlpConfig_1.post)(url, { json: jsonObj })];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); },
    getStudentPlacements: function (studentGuid, subjectId, pathwayType) {
        var params = (0, getDefaultParams_1.default)();
        var url = "".concat(params.educatorUserUrl, "/v2/placement?studentId=").concat(studentGuid, "&subject=").concat(subjectId !== null && subjectId !== void 0 ? subjectId : "", "&pathwayType=").concat(pathwayType !== null && pathwayType !== void 0 ? pathwayType : "");
        return (0, ky_imlpConfig_1.get)(url)
            .then(function (response) { return response.json(); })
            .then(function (response) { return ({ status: service_status_enum_1.default.LOADED, data: response }); })
            .catch(function (error) { return ({ status: service_status_enum_1.default.ERROR, data: error }); });
    },
    getPendoMetadata: function (userGuid) {
        var params = (0, getDefaultParams_1.default)();
        var url = "".concat(params.educatorUserUrl, "/api/studentpendometadata?userGuid=").concat(userGuid);
        return (0, ky_imlpConfig_1.get)(url)
            .then(function (response) { return response.json(); })
            .then(function (response) { return ({ status: service_status_enum_1.default.LOADED, data: response }); })
            .catch(function (error) { return ({ status: service_status_enum_1.default.ERROR, data: error }); });
    }
};
exports.default = EducatorUserService;
